import React, { useState, useEffect } from 'react';
import UserIcon from 'assets/icon/UserIcon';
import SettingIcon from 'assets/icon/SettingIcon';
import DashboardIcon from 'assets/icon/DashboardIcon';
import CreditCardIcon from 'assets/icon/CreditCardIcon';
import GroupIcon from 'assets/icon/GroupIcon';
import TableIcon from 'assets/icon/TableIcon';
import CalculatorIcon from 'assets/icon/CalculatorIcon';
import LineChartIcon from 'assets/icon/LineChartIcon';
import MoneyIcon from 'assets/icon/MoneyIcon';
import PinLocationIcon from 'assets/icon/PinLocationIcon';
import BankIcon from 'assets/icon/BankIcon';
import TransferIcon from 'assets/icon/TransferIcon';
import MoneyWithdrawIcon from 'assets/icon/MoneyWithdrawIcon';

export default function Sidebar({ isOpen, onSidebarClick }) {
	const [isSidebarHome, setIsSidebarHome] = useState(true)
	const [isAdmin, setIsAdmin] = useState("0")
	let pathArray = window.location.pathname.split("/")
	
	useEffect(() => {
		setIsAdmin(localStorage.getItem("IsAdmin"))
		// setIsAdmin("1")
	}, [])

	useEffect(() => {
		if (pathArray[1] === "location"){
			setIsSidebarHome(false)
		}else{
			setIsSidebarHome(true)
		}
	}, [pathArray])
  
	return (
		<div className={`fixed sm:relative h-screen bg-white shadow-md transition-all z-20
			${ isOpen ? 'w-full sm:w-64' : 'hidden sm:block sm:w-20' }`}
		>
			<div className={`h-screen flex flex-col items-center gap-6 lg:text-base py-4 w-full`}>
				<div className="items-start flex flex-col w-full gap-2 px-2 overflow-y-auto mb-24 sm:mb-12">
					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } 
							${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} 
							cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/dashboard' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/dashboard"
					>
						<DashboardIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Dashboard</p>
					</a>

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' } 
						`}
						onClick={onSidebarClick}
						href="/"
					>
						<CalculatorIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Transaction</p>
					</a>

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/transfer' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' } 
						`}
						onClick={onSidebarClick}
						href="/transfer"
					>
						<TransferIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Transfer</p>
					</a>

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/pelunasan' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' } 
						`}
						onClick={onSidebarClick}
						href="/pelunasan"
					>
						<CalculatorIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Pelunasan</p>
					</a>

					{/* <a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/transfer-pl' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' } 
						`}
						onClick={onSidebarClick}
						href="/transfer-pl"
					>
						<TransferIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Transfer PL</p>
					</a>

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/cash-in' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' } 
						`}
						onClick={onSidebarClick}
						href="/cash-in"
					>
						<MoneyWithdrawIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Cash In</p>
					</a> */}

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/customer' ? 'bg-slate-300' : '' }
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/customer"
					>
						<GroupIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Pelanggan</p>
					</a>

					<a className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/customer-card' ? 'bg-slate-300' : '' }
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/customer-card"
					>
						<CreditCardIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Kartu Pelanggan</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/transaction-report' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }\
						`}
						onClick={onSidebarClick}
						href="/transaction-report"
					>
						<TableIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Laporan</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/daily-transaction-report' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }\
						`}
						onClick={onSidebarClick}
						href="/daily-transaction-report"
					>
						<TableIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Laporan Harian</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/payment-received' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }\
						`}
						onClick={onSidebarClick}
						href="/payment-received"
					>
						<MoneyIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Payment</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname === '/statistic-report' ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }\
						`}
						onClick={onSidebarClick}
						href="/statistic-report"
					>
						<LineChartIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Statistic Report</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/beneficiary-account') ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/beneficiary-account"
					>
						<BankIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Beneficiary Account</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/edc-location') ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/edc-location"
					>
						<PinLocationIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>EDC Location</p>
					</a>

					<div className={`${ isOpen ? 'hidden sm:block' : 'hidden' }`}>
						<span>Human Resource</span>
					</div>
					
					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/edc-location') ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/hr/employee"
					>
						<UserIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Employee</p>
					</a>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/edc-location') ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/hr/payroll"
					>
						<MoneyIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Payroll</p>
					</a>

					<div className={`${ isOpen ? 'hidden sm:block' : 'hidden' }`}>
						<span>Setting</span>
					</div>

					<a
						className={`w-full py-3 ${ isOpen ? 'px-4' : 'px-2' } cursor-pointer hover:bg-slate-300 transition-all rounded-md flex items-center
							${ window.location.pathname.includes('/setting') ? 'bg-slate-300' : '' } 
							${ isOpen ? '' : 'justify-center' }
						`}
						onClick={onSidebarClick}
						href="/setting"
					>
						<SettingIcon className='fill-black w-6' />
						<p className={`px-4 ${ isOpen ? 'block' : 'hidden' }`}>Setting</p>
					</a>
				</div>
			</div>
		</div>
  	)
}
